import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';
import { FetchOptionType, IOptionType } from "../../types/common";
import { FilterPopover } from "../../components";
import { useLoadOptions } from "../../hooks/useLoadOptions";
import { useTranslation } from "react-i18next";
import { selectedItemGroupsKey, selectedManufacturersKey } from "../../utils/imageMatcherUtil";

export const ImageMatcherFilter: React.FC = () => {
    const { t } = useTranslation();
    const [selectedManufacturerOptions, setSelectedManufacturerOptions] = useState<IOptionType[]>([])
    const [selectedItemGroupOptions, setSelectedItemGroupOptions] = useState<IOptionType[]>([])
    const {
        manufacturerOptions,
        itemGroupOptions
    } = useLoadOptions([FetchOptionType.Manufacturer, FetchOptionType.ItemGroups]);

    const handleApplyFilter = () => {
        localStorage.removeItem(selectedManufacturersKey);
        localStorage.removeItem(selectedItemGroupsKey);
        if (selectedManufacturerOptions.length > 0) {
            localStorage.setItem(selectedManufacturersKey, JSON.stringify(selectedManufacturerOptions));
        }
        if (selectedItemGroupOptions.length > 0) {
            localStorage.setItem(selectedItemGroupsKey, JSON.stringify(selectedItemGroupOptions));
        }
    }

    return (
        <FilterPopover
            id="matched-pairs-filter"
            title={t("OnlyMatchToOEM.FilterTitle")}
            isLoading={false}
            onApplyFilter={handleApplyFilter}
            t={t}
        >
            <Form onSubmit={handleApplyFilter}>
                <Form.Group className="mb-3">
                    <Form.Label>{t("Filter.manufacturer")}(s):</Form.Label>
                    <CreatableSelect
                        className="card border-0"
                        closeMenuOnSelect={false}
                        isMulti
                        options={manufacturerOptions}
                        value={selectedManufacturerOptions}
                        placeholder={t("Filter.manufacturer")}
                        isSearchable
                        onChange={(values) => setSelectedManufacturerOptions(values as IOptionType[])}
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>{t("Filter.itemgroup")}</Form.Label>
                    <CreatableSelect
                        className="border-0 d-md-block"
                        closeMenuOnSelect={false}
                        isMulti
                        options={itemGroupOptions}
                        value={selectedItemGroupOptions}
                        placeholder={t("Filter.itemgroup")}
                        isSearchable
                        onChange={(values) => setSelectedItemGroupOptions(values as IOptionType[])}
                    />
                </Form.Group>
            </Form>
        </FilterPopover>
    );
};
